import shopifyEllaGenericDefaults from '../shopify-ella-generic/config.js';

export default {
  includes: ['shopify-ella-generic'],
  ...shopifyEllaGenericDefaults,
  fitmentSearch: {
    ...shopifyEllaGenericDefaults.fitmentSearch,
  },
  Widgets: [
    ...shopifyEllaGenericDefaults.Widgets,
    {
      name: 'WheelTireVehicleInfo',
      useAutoSyncVisualizer: true,
    },
    {
      name: 'UpsizeDownsizeFacetPanel',
      type: 'FacetPanel',
      fields: ['wheel_tire_diameter'],
      showAllAlways: true,
      disableCollapse: true,
    },
  ],
};
